export default __webpack_public_path__ + "static/media/alert-orange.26627e99.svg";